import { StorageReference } from '@angular/fire/storage';
import { FileExtra } from '@ih/app/client/shared/interfaces';

export class DeleteAction {
  public static readonly type = '[Project/Storage/List] DeleteAction';
  constructor(
    public readonly file: (StorageReference & FileExtra) | StorageReference,
  ) {}
}
